export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/apps_step-on-9eef70ba776dea1da2d4f9b2252c6285.png";